'use strict';

module.exports = ['$rootScope', function($rootScope) {

  return {
    'request': function (request) {

      if(request.cache === undefined){
        if (request.url.indexOf('http') === -1) {
          // adjust api path
          if (window.location.host === "www2.gesundheitsforen.net") {
            request.url = "https://www2.gesundheitsforen.net/emil-mdat" + request.url;
          } else if (window.location.host.match(/localhost/)) {
            request.url = "http://localhost:8080" + request.url;
          }

          // redirect live preview to normal backend path
          //if (window.location.host === "localhost:9000"){
          //}
        }

        $rootScope.$broadcast('http:request');
      }

      return request;
    }
  };
}];



// WEBPACK FOOTER //
// ./src/main/webapp-files/modules/app/services/defaultinterceptor.js